<template>
  <div>
    <van-pull-refresh v-model="isLoading" @refresh="getPostsAsync">  
      <van-skeleton  v-for="post in posts" :key="post.id" avatar :row="3" :loading="loading">
        <!-- <van-contact-card 
          type="edit" :name="post.no+' - '+post.cari_ad" :tel="post.cep +' / '+ $helper.trtgoster(post.ptarih)+' B:'+post.barkod" :editable="true"
          :icon = "icons(post.sdid)"
          :to="`/servis/${post.sid * 8589}`"
        /> -->
        <van-contact-card 
          type="edit" :name="$helper.ilkharfBuyuk(post.cari)" :tel="post.gsm +' / '+ $helper.trtgoster(post.ptarih)+' '+post.psaat+' '+$helper.ilkharfBuyuk(post.adres)" :editable="true"
          :icon = "icons(post.sdid)"
          :to="`/servis/${post.sid * 8589}`"
        />
      </van-skeleton>
    </van-pull-refresh>
        <div style="height:70px"></div>
         <van-tabbar v-model="active">
          <van-tabbar-item name="Home" to="/" icon="wap-home-o">Home</van-tabbar-item>
          <van-tabbar-item name="Servis" to="/servis" icon="todo-list-o">Servis</van-tabbar-item>
          <van-tabbar-item name="Sepet" to="/sepet" icon="cluster-o">Ekibim</van-tabbar-item>
          <van-tabbar-item name="Depom" to="/depo" icon="apps-o">Depom</van-tabbar-item>
          <van-tabbar-item name="Cihaz" to="/gruplama" icon="fire-o">Cihaz</van-tabbar-item>
          <van-tabbar-item name="Hesabım" to="/hesap" icon="user-o">Hesap</van-tabbar-item>
         </van-tabbar>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      loading:true, //skelaton için
      posts:[],
      error:[],
      donem: this.$request.donem(),
      active:'Servis',
      ayar:this.$request.ayar(),
      isLoading: false,
      table:''
    };
  },
mounted(){
    this.yetki()
  },
  methods: {
          yetki:function(){
          let baslat = false;
          let table ='';
            if (this.ayar.ya==='sid'){
                this.table = 'servis'
                baslat = true
                this.getPostsAsync(table,baslat)
            }
            else{
              this.table = 'kayit'
              baslat=true
              this.getPostsAsync(table,baslat)
            }
          }, 
        getPostsAsync (){
          this.$request.get("servis/mobilservis/"+this.ayar.ya+"/"+this.ayar.kid+'/'+this.table)
          .then(res => {
            console.log(res.results)
              this.posts = res.results.sort((t1,t2) => t2.sid < t1.sid ? -1 : 1)
              setTimeout(() => {  this.loading = false ; this.isLoading = false;}, 500);

        })
        .catch(err => {this.error.push(err)})
        },
        icons(id){
          
          if (id===2){
            return "question-o"
          }
          else{
            return "clock-o"
          }
        }
  },

};
</script>


// WEBPACK FOOTER //
// src/components/servis/servis.vue